import React from 'react';
import { useNavigate } from "react-router-dom";
import { Box, Divider, IconButton, Menu, MenuItem, Fade, ListItemText, ListItemIcon } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FormMode, USysObjects } from '../utils/extensions/constantEx';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { HomeContext } from '../utils/contexts/homeContext';

const BookingMenuPopup = (props) => {
    const { bookingRow, handleDeleteClick } = props;
    const { homeState } = React.useContext(HomeContext);


    const [anchorEl, setAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);
    const navigate = useNavigate();

    const handleMenuEditClick = () => {
        handleMoreClose();
        navigate("/nurse-service-booking-form", {
            replace: false,
            state: {
                from: 'nurse-service-booking-search',
                formMode: FormMode.ViewMode,
                selectedId: bookingRow.id,
                selectedNurseId: bookingRow.nurse_id,
                selectedNurseName: bookingRow.nurse_name
            }
        });
    }

    const handleMenuDeleteClick = () => {
        handleMoreClose();
        handleDeleteClick(bookingRow.id);
    }

    const handleMoreClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMoreClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box>
            <IconButton onClick={handleMoreClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="fade-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMoreClose}
                slotProps={{
                    transition: Fade
                }}
            >
                <MenuItem onClick={handleMenuEditClick} disableRipple>
                    <ListItemIcon>
                        <VisibilityIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>View</ListItemText>
                </MenuItem>
                <Divider sx={{ my: 0.5 }} />

                {
                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_delete) &&
                    <MenuItem onClick={handleMenuDeleteClick} disableRipple>
                        <ListItemIcon>
                            <RemoveCircleOutlineIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Delete</ListItemText>
                    </MenuItem>
                }
            </Menu>

        </Box>

    );
}
export default BookingMenuPopup;